export default function ProspectsConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('prospects');
}

ProspectsConfiguration.$inject = ['$translatePartialLoaderProvider'];
